/**
 * Pushes rendez_vous mutations to the user's iCloud calendar via the
 * Cloudflare Worker (/api/icloud/*). Single-user feature — gated server-side
 * by an email whitelist.
 *
 * Calls are fire-and-forget: UI never waits for the sync. The worker persists
 * sync status on the rendez_vous row, and a server-side cron picks up
 * transient failures.
 */
import { supabase } from '@/lib/supabase'

const API_BASE = import.meta.env.VITE_EMAIL_API_URL || 'https://api.lessablesweb.fr'

async function authedFetch(path: string, init: RequestInit): Promise<void> {
  const { data } = await supabase.auth.getSession()
  const token = data?.session?.access_token
  if (!token) return

  try {
    const res = await fetch(`${API_BASE}${path}`, {
      ...init,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(init.headers ?? {}),
      },
    })
    // We only care about logging here; status is also persisted in DB by the worker.
    if (!res.ok && res.status !== 503) {
      console.warn('[icloudSync] non-ok response', res.status)
    }
  } catch (err) {
    console.warn('[icloudSync] network error', err)
  }
}

export const icloudSyncService = {
  upsert(rdvId: string): void {
    void authedFetch('/api/icloud/events', {
      method: 'POST',
      body: JSON.stringify({ rdv_id: rdvId }),
    })
  },

  delete(rdvId: string): void {
    void authedFetch(`/api/icloud/events/${rdvId}`, { method: 'DELETE' })
  },
}
